import HistoryLocationActions from './HistoryLocationActions';
import openOrUpdatePage from './openOrUpdatePage';
const { goTo, replaceLocation } = HistoryLocationActions;

export default {
    goTo,
    openOrUpdatePage,
    replaceLocation
};
